import {
  BaseActionObject,
  StateNodeConfig,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"
import { BASE_SP_V2_SETTINGS_PATH } from "../../../studyPlanV2/constants"

const getOnDoneAction = () => ({
  snackbar: {
    message: "Settings saved",
    withUndo: false,
    error: false
  }
})

export const saveGlobalPlanSettingsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "saveGlobalPlanSettings",
    onDone: [
      {
        target: `${BASE_SP_V2_SETTINGS_PATH}.loading`,
        actions: assign<Context, DoneInvokeEvent<any>>(getOnDoneAction),
        cond: ctx => ctx.isStudyPlanV2Enabled
      },
      {
        target: "#StudyPlan.study_plans_overview.get_global_settings",
        actions: assign<Context, DoneInvokeEvent<any>>(getOnDoneAction)
      }
    ],
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("saveGlobalSettings", {
            messageData: ["save plan error"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
